import React, { useRef } from 'react';

import acit from '../images/schools/acit.png';
import bernards from '../images/schools/bernards.png';
import boundbrook from '../images/schools/boundbrook.png';
import carteret from '../images/schools/carteret.png';
import delran from '../images/schools/delran.jpg';
import eggharbor from '../images/schools/eggharbor.png';
import franklin from '../images/schools/franklin.png';
import hunterdoncentral from '../images/schools/hunterdoncentral.png';
import leonia from '../images/schools/leonia.png';
import metuchen from '../images/schools/metuchen.png';
import montgomery from '../images/schools/montgomery.png';
import nbths from '../images/schools/nbths.png';
import nvd from '../images/schools/nvd.png';
import nvot from '../images/schools/nvot.png';
import union from '../images/schools/union.png';

export default function ScrollingSchools() {
  const schoolsArray = useRef([
    {img:acit, name:"Atlantic County Institute of Technology"},
    {img:bernards, name:"Bernards Township Schools"},
    {img:boundbrook, name:"Bound Brook High School"},
    {img:carteret, name:"Carteret Public Schools"},
    {img:delran, name:"Delran High School"},
    {img:eggharbor, name:"Egg Harbor Township School District"},
    {img:franklin, name:"Franklin High School"},
    {img:hunterdoncentral, name:"Hunterdon Central Regional High School"},
    {img:leonia, name:"Leonia High School"},
    {img:metuchen, name:"Metuchen High School"},
    {img:montgomery, name:"Montgomery Township School District"},
    {img:nbths, name:"North Brunswick Township High School"},
    {img:nvd, name:"Northern Valley - Demarest"},
    {img:nvot, name:"Northern Valley - Old Tappan"},
    {img:union, name:"Union High School"},
  ]);

    return (
        <>
        <p>Trusted by high schools across the country</p>

        <div className="trust-scroll-wrapper">
            <div className="trust-scroll infinite">
                {schoolsArray.current.concat(schoolsArray.current).map((school_info, i) => (
                <div className="trust-item" key={i}>
                <div className="trust-logo"><img src={school_info.img} alt={school_info.name} /></div>
                </div>
                ))}
            </div>
        </div>
        </>
    );
}
